/**
 * Smart Haptic Feedback Utility
 * Only triggers on meaningful actions, not every tap
 * 
 * Uses: Booking submitted, Visit marked done, Target milestone crossed
 */

// Check if vibration is supported
const canVibrate = () => {
  return 'vibrate' in navigator;
};

// Light haptic - subtle feedback
export const hapticLight = () => {
  if (canVibrate()) {
    navigator.vibrate(10);
  }
};

// Medium haptic - action confirmation
export const hapticMedium = () => {
  if (canVibrate()) {
    navigator.vibrate(25);
  }
};

// Strong haptic - important action
export const hapticStrong = () => {
  if (canVibrate()) {
    navigator.vibrate(50);
  }
};

// Success pattern - booking submitted, visit complete
export const hapticSuccess = () => {
  if (canVibrate()) {
    navigator.vibrate([30, 50, 30]);
  }
};

// Celebration pattern - milestone reached, target achieved
export const hapticCelebration = () => {
  if (canVibrate()) {
    navigator.vibrate([50, 30, 50, 30, 100]);
  }
};

// Error pattern - action failed
export const hapticError = () => {
  if (canVibrate()) {
    navigator.vibrate([100, 50, 100]);
  }
};

// Warning pattern - important notice
export const hapticWarning = () => {
  if (canVibrate()) {
    navigator.vibrate([50, 100, 50]);
  }
};

export default {
  light: hapticLight,
  medium: hapticMedium,
  strong: hapticStrong,
  success: hapticSuccess,
  celebration: hapticCelebration,
  error: hapticError,
  warning: hapticWarning,
};
